export class AssumedValuesTabGroup {
  basicDetailsTab: boolean;
  multiInvestorTab: boolean;
  projectConstructionTab: boolean;
  netOperatingIncomeTabGroup: netOperatingIncomeTabGroup;
  taxesTab: boolean;
  taxEquityTab: boolean;
  cashEquityTab: boolean;

  constructor() {
    this.basicDetailsTab = false;
    this.multiInvestorTab = false;
    this.projectConstructionTab = false;
    this.netOperatingIncomeTabGroup = new netOperatingIncomeTabGroup();
    this.taxesTab = false;
    this.taxEquityTab = false;
    this.cashEquityTab = false;
  }

  expandAll(): void {
    this.basicDetailsTab = true;
    this.multiInvestorTab = true;
    this.projectConstructionTab = true;
    this.taxesTab = true;
    this.taxEquityTab = true;
    this.cashEquityTab = true;
    this.netOperatingIncomeTabGroup.expandAll();
  }

  closeAll(): void {
    this.basicDetailsTab = false;
    this.multiInvestorTab = false;
    this.projectConstructionTab = false;
    this.taxesTab = false;
    this.netOperatingIncomeTabGroup.closeAll();
    this.taxEquityTab = false;
    this.cashEquityTab = false;
  }

  toggleBasicDetailsTab(): void {
    this.basicDetailsTab = !this.basicDetailsTab;
  }

  toggleMultiInvestorTab(): void {
    this.multiInvestorTab = !this.multiInvestorTab;
  }

  toggleProjectConstructionTab(): void {
    this.projectConstructionTab = !this.projectConstructionTab;
  }

  toggleTaxesTab(): void {
    this.taxesTab = !this.taxesTab;
  }

  toggleTaxEquityTab(): void {
    this.taxEquityTab = !this.taxEquityTab;
  }

  toggleCashEquityTab(): void {
    this.cashEquityTab = !this.cashEquityTab;
  }
}

export class netOperatingIncomeTabGroup {
  netOperatingIncomeTab: boolean;
  generalTab: boolean;
  incentiveTab: boolean;
  operatingAndManagementExpenseTab: boolean;
  insuranceExpenseTab: boolean;
  cellServiceExpenseTab: boolean;
  creditCardExpenseTab: boolean;
  inverterReplacementExpenseTab: boolean;
  assetManagementTab: boolean;
  systemRemovalTab: boolean;

  expandAll(): void {
    this.netOperatingIncomeTab = true;
    this.generalTab = true;
    this.incentiveTab = true;
    this.operatingAndManagementExpenseTab = true;
    this.insuranceExpenseTab = true;
    this.cellServiceExpenseTab = true;
    this.creditCardExpenseTab = true;
    this.inverterReplacementExpenseTab = true;
    this.assetManagementTab = true;
    this.systemRemovalTab = true;
  }

  closeAll(): void {
    this.netOperatingIncomeTab = false;
    this.generalTab = false;
    this.incentiveTab = false;
    this.operatingAndManagementExpenseTab = false;
    this.insuranceExpenseTab = false;
    this.cellServiceExpenseTab = false;
    this.creditCardExpenseTab = false;
    this.inverterReplacementExpenseTab = false;
    this.assetManagementTab = false;
    this.systemRemovalTab = false;
  }

  toggleEntireTab(): void {
    this.netOperatingIncomeTab = !this.netOperatingIncomeTab;
  }

  toggleGeneralTab(): void {
    this.generalTab = !this.generalTab;
  }

  toggleSrecTab(): void {
    this.incentiveTab = !this.incentiveTab;
  }

  toggleOperatingAndManagementExpenseTab(): void {
    this.operatingAndManagementExpenseTab = !this
      .operatingAndManagementExpenseTab;
  }

  toggleInsuranceExpenseTab(): void {
    this.insuranceExpenseTab = !this.insuranceExpenseTab;
  }

  toggleCellServiceExpenseTab(): void {
    this.cellServiceExpenseTab = !this.cellServiceExpenseTab;
  }

  toggleCreditCardExpense(): void {
    this.creditCardExpenseTab = !this.creditCardExpenseTab;
  }

  toggleInverterReplacementExpense(): void {
    this.inverterReplacementExpenseTab = !this.inverterReplacementExpenseTab;
  }

  toggleAssetManagementExpenseTab(): void {
    this.assetManagementTab = !this.assetManagementTab;
  }

  toggleSystemRemovalTab(): void {
    this.systemRemovalTab = !this.systemRemovalTab;
  }
}
